/* CTR Creatine — details accordion (sections/ctr-creatine-details.liquid)
   One item is always open; opening an item swaps the matching media panel. */
if (!customElements.get('ctr-creatine-details')) {
  class CtrCreatineDetails extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.ctr-creatine-details__item'));
      this.panels = Array.from(this.querySelectorAll('.ctr-creatine-details__panel'));

      this.items.forEach((item, index) => {
        const trigger = item.querySelector('[data-trigger]');
        if (trigger) trigger.addEventListener('click', () => this.open(index));
      });

      // Theme editor: open the item a merchant selects in the sidebar.
      this.onBlockSelect = (event) => {
        const index = this.items.findIndex((item) => item.dataset.blockId === event.detail.blockId);
        if (index > -1) this.open(index, false);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    open(index, animate = true) {
      this.items.forEach((item, i) => {
        const isActive = i === index;
        const trigger = item.querySelector('[data-trigger]');
        const body = item.querySelector('.ctr-creatine-details__body');
        item.classList.toggle('is-active', isActive);
        if (trigger) trigger.setAttribute('aria-expanded', String(isActive));
        if (body) body.inert = !isActive;
      });

      this.panels.forEach((panel, i) => {
        const isActive = i === index;
        const wasHidden = panel.hidden;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
        if (isActive && wasHidden && animate) {
          panel.classList.remove('is-entering');
          void panel.offsetWidth;
          panel.classList.add('is-entering');
        }
      });
    }
  }

  customElements.define('ctr-creatine-details', CtrCreatineDetails);
}
